import React from 'react';
import { useTranslation } from 'react-i18next';

import { Theme } from '@material-ui/core/styles/createTheme';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { fractionToPercent } from 'helpers/helpers';
import CO2Icon from 'components/Icons/CO2Icon';
import CCIcon from 'components/Icons/CCIcon';
import BenchmarkIcon from 'components/Icons/BenchmarkIcon';

//import { Portfolio } from 'apps/Pdf/templates/Interfaces';
import { Portfolio } from 'stores/workflowStores/newWorkflowPlanStore/model/interfaces';
import { EdwardColors } from 'enums';
const blackRock = require('assets/icons/ishares_br.png');

const styles = (theme: Theme) => ({
  root: {
    width: '250px',
    paddingTop: '4px',
    '& svg': { width: '40px', height: '40px' },
    '& img': { height: '40px' },
    '& > div': {
      fontWeight: 'bold',
      color: EdwardColors.GREEN,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '&.blackrock': {
        fontSize: '9px',
        fontWeight: 'normal',
        color: 'black',
        textAlign: 'right',
      },
    },
  },
});

interface Props {
  portfolio: Portfolio;
}

const ESG = (props: Props) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      {props.portfolio.msciRating && (
        <div>
          <BenchmarkIcon defaultStroke />
          <span>
            {t('esg_msciRating')}: {fractionToPercent(props.portfolio.msciRating)}*
          </span>
        </div>
      )}
      {props.portfolio.carbon && (
        <div>
          <CO2Icon />
          <span>
            {t('esg_carbon')}: {fractionToPercent(props.portfolio.carbon)}*
          </span>
        </div>
      )}
      <div>
        <CCIcon /> <span>{t('esg_cc')}: 0 %</span>
      </div>
      <div className="blackrock">
        <img src={blackRock.default} alt="iShares BlackRock" />
        <span> {t('esg_blackrock')}</span>
      </div>
    </div>
  );
};

export default ESG;
